import isEmpty from "lodash/isEmpty";

import { IURLPathParams, IURLSearchParams } from "./types";

type FPathFrom = (url: string, pathParams: IURLPathParams) => string;
type FSearchFrom = (searchParams: IURLSearchParams) => string;

export const composeBuilder = (pathFrom: FPathFrom, searchFrom: FSearchFrom) => {
  return (url: string, path: IURLPathParams = {}, search: IURLSearchParams = {}) => {
    return `${pathFrom(url, path)}${isEmpty(search) ? "" : `?${searchFrom(search)}`}`;
  };
};
